/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { IoIosArrowBack, IoMdSend } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import { showToast } from "../../showTost";
import { socket } from "../../socket";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import { formatIstDate, formatIstTime } from "../../utils/datetime";

const Chat = ({ index, setShowChat, doctorId }) => {

  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [user, setUser] = useState();
  const [input, setInput] = useState("");
  const [chatData, setChatData] = useState([]);
  const [chatUser, setChatUser] = useState([]);
  const [selectUser, setSelectUser] = useState();
  const [loading, setLoading] = useState(true);
  const [isShow, setIsShow] = useState(false);
  const [search, setSearch] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [apiloading, setApiLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [lastScrollTop, setLastScrollTop] = useState("");
  const [hasMore, setHasMore] = useState(true);

  const chatBoxBodyRef = useRef(null);
  const NoMoreDataRef = useRef(true);
  const ClassRef = useRef();

  useEffect(() => {
    if (page === 1 && chatBoxBodyRef.current) {
      chatBoxBodyRef.current.scrollTop = chatBoxBodyRef.current.scrollHeight;
    }
  }, [chatData]);

  useEffect(() => {
    handleGetMessage(1);
  }, [doctorId]);

  const handleGetMessage = (page) => {

    const Userid = secureLocalStorage.getItem("Userid");
    const RecevierId = Userid === Number(selectUser?.sender_id) ? selectUser?.receiver_id : selectUser?.sender_id;

    if ((doctorId || RecevierId) && Userid) {

      if (page === 1) {
        setApiLoading(true);
      }

      const Data = {
        id: Userid,
        sender_id: Userid,
        recevier_id: RecevierId,
        status: "customer",
        page
      };

      axios.post(`${ApiBaseUrl}/chat/user_to_user_chat_list`, Data)
        .then((res) => {
          // console.log("user_to_user_chat_list", res);
          if (res.data.ResponseCode === 200) {
            const AllChat = res.data.all_chat;
            if (AllChat.length === 0) NoMoreDataRef.current = false;
            if (page === 1) {
              setChatData(AllChat);
            } else {
              setChatData(prev => [...prev, ...AllChat]);
            }
          }
          setHasMore(true);
          setApiLoading(false);
          if (res.data.user) {
            setUser(res.data.user[0]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleScroll = (e) => {
    const { scrollTop } = e.target;
    if (scrollTop < lastScrollTop) {
      if (scrollTop <= 10 && hasMore && NoMoreDataRef.current) {
        setHasMore(false);
        setPage(prev => prev + 1);
      }
    }
    setLastScrollTop(scrollTop);
  };

  useEffect(() => {
    if (page === 1 && !NoMoreDataRef.current) return;

    handleGetMessage(page);
  }, [page])

  useEffect(() => {
    handleGetChatUser(0, 1);
  }, []);

  const handleGetChatUser = (index, page) => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      axios.post(`${ApiBaseUrl}/chat/all_chat`, { id: Userid, status: "customer", page })
        .then((res) => {
          // console.log("all_chat", res);
          setLoading(false);
          setChatUser(res.data.chat_list);
          setFilterData(res.data.chat_list);

          if (index === 0 && window.innerWidth > 770) {
            setSelectUser(res.data.chat_list[0]);
            handleGetMessage(1);
          }
        })

        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleSelectUser = (item) => {
    setSelectUser(item);
    setPage(1);
    setHasMore(true);
    NoMoreDataRef.current = true;

    if (window.innerWidth < 770) {
      setIsShow(true);
    }
  };

  useEffect(() => {
    handleGetMessage(1);

    setTimeout(() => {
      handleGetChatUser(1, 1);
    }, 1000);

    const Userid = secureLocalStorage.getItem("Userid");
    const Index = Userid === selectUser?.sender_id ? selectUser?.receiver_id : selectUser?.sender_id;
    sessionStorage.setItem("Selectid", Index);

  }, [selectUser]);

  const handleSendMessage = () => {

    if (!selectUser) {
      showToast({ title: t("Please Select User !!"), id: "error" });
      return;
    }

    if (!input) {
      showToast({ title: t("Please Write Message !!"), id: "error" });
      return;
    }

    const Userid = secureLocalStorage.getItem("Userid");

    if (Userid) {

      const RecevierId = Userid === Number(selectUser?.sender_id) ? selectUser?.receiver_id : selectUser?.sender_id;

      const Data = {
        id: Userid,
        sender_id: Userid,
        recevier_id: doctorId || RecevierId,
        message: input,
        dstatus: 2,
        status: "customer"
      };

      socket.emit("Add_new_chat", Data);
      HandleAddChat();
      axios.post(`${ApiBaseUrl}/chat/save_chat`, Data).catch((err) => {
        console.error("save_chat fallback error:", err);
      });

      setInput("");
    }

  };

  useEffect(() => {
    const Userid = secureLocalStorage.getItem("Userid");

    const handleNewChat = (msg) => {
      setChatData((prev) => {
        const newPrev = [...prev];
        
        const Chat = {
          date: msg.date,
          message: msg.messages,
          status: 1,
          recevier_id: msg.recevier_id,
          sender_id: msg.sender_id
        };

        if (msg.today === "0") {
          if (newPrev.length > 0) {
            const lastIndex = newPrev.length - 1;
            const updatedGroup = {
              ...newPrev[lastIndex],
              chat: [Chat, ...newPrev[lastIndex].chat],
            };
            newPrev[lastIndex] = updatedGroup;
            return newPrev;
          } else {
            return [{ date: msg.today, chat: [Chat] }];
          }
        } else {
          return [{ date: msg.today, chat: [Chat] }, ...newPrev];
        }
      });

    }

    socket.on(`Web_Device_Chat_Reaload${Userid}`, handleNewChat);

    return () => {
      socket.off(`Web_Device_Chat_Reaload${Userid}`, handleNewChat);
    };
  }, [])

  const HandleAddChat = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    const now = new Date();
    const formattedDate = formatIstDate(now);
    const timeString = formatIstTime(now);

    setChatData((prev) => {

      const existingIndex = prev.findIndex((group) => group.date === formattedDate);

      const Chat = {
        id: Number(Userid),
        date: timeString,
        message: input,
        status: 1,
      };

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          chat: [Chat, ...updated[existingIndex].chat],
        };
        return updated;
      } else {
        return [{ date: formattedDate, chat: [Chat] }, ...prev];
      }
    });
  };

  useEffect(() => {
    const Userid = secureLocalStorage.getItem("Userid");

    const handleNewChat = (msg) => {

      setTimeout(() => {
        handleGetChatUser(1, 1);
      }, 1000);

      const ID = sessionStorage.getItem("Selectid");

      const SenderID = Userid === msg?.sender_id ? msg?.receiver_id : msg?.sender_id;

      if (ID === SenderID) {

        socket.emit("Web_Chat_Read", { sender_id: msg.sender_id, recevier_id: msg.recevier_id, status: "customer" });

        setChatData((prev) => {

          const newPrev = [...prev];

          const Chat = {
            date: msg.date,
            message: msg.messages,
            status: 2,
            recevier_id: msg.recevier_id,
            sender_id: msg.sender_id
          };

          if (msg.today === "0") {
            if (newPrev.length > 0) {
              const lastIndex = newPrev.length - 1;
              const updatedGroup = {
                ...newPrev[lastIndex],
                chat: [Chat, ...newPrev[lastIndex].chat],
              };
              newPrev[lastIndex] = updatedGroup;
              return newPrev;
            } else {
              return [{ date: msg.today, chat: [Chat] }];
            }
          } else {
            return [{ date: msg.today, chat: [Chat] }, ...newPrev];
          }
        });
      }
    };

    socket.on(`New_Chat_Reaload${Userid}`, handleNewChat);

    return () => {
      socket.off(`New_Chat_Reaload${Userid}`, handleNewChat);
    };

  }, []);




  useEffect(() => {
    if (chatUser.length >= 1) {
      const FilterData = search ? chatUser.filter(item => item.name.toLowerCase().includes(search.toLowerCase())) : chatUser;
      setFilterData(FilterData);
    }
  }, [search]);

  return (
    <div>
      {(index !== 1 && false)
        ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
        : <div className="chat_box">
          {index === 1
            ? <div className="border-[1px] border-[#8080803b] rounded-[10px]">
              <div className="flex items-center gap-[15px] p-[10px]">
                <button
                  onClick={() => setShowChat(false)}><FaArrowLeftLong className='text-[20px]' /></button>
                <div className="flex items-center gap-[10px]">
                  <img src={ImgBaseUrl + user?.logo} className='w-[40px] h-[40px] rounded-[100%] object-cover' alt="" />
                  <h1 className='font-[500] text-[18px]'>{user?.name}</h1>
                </div>
              </div>

              <div className="border-t-[1px] border-[#8080803b]"></div>

              <div ref={chatBoxBodyRef} className="msg_box scroll-container px-[10px] chat_bg">
                {chatData.length >= 1
                  ? chatData.map((item, index) => {
                    return <div key={index} className="mb-[5px] mt-[10px]">
                      <h1 className="text-center font-[500] text-[15px]">{item.date}</h1>
                      {item.chat.map((item, index) => {
                        return <div key={index} className="msg_list mt-[5px]">
                          <div className={`message bg-gray-200 ${item.status === 1 ? "sender" : "recevier"}`}>
                            <pre className="font-[500] whitespace-pre-wrap">{item.message}</pre>
                            <span className="text-[14px]">{item.date}</span>
                          </div>
                        </div>
                      })}
                    </div>
                  })
                  : <div className="h-[100%] flex items-center justify-center">
                    <h1>Loading.....</h1>
                  </div>}
              </div>

              <div className="p-[10px] flex items-center gap-[10px]">
                <input value={input}
                  onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSendMessage();
                    }
                  }}
                  type="text" className='w-[100%] border-[2px] border-[#8080803b] rounded-[10px] py-[8px] px-[10px] font-[500] focus-within:border-[#0d9488]' placeholder={t('Say Something...')} />
                <button onClick={handleSendMessage} className="bg-[#0d9488] rounded-[10px] p-[10px]"><IoMdSend className="text-[20px] text-white" /></button>
              </div>
            </div>
            : <div className="main_box">
              <div className={`user_box bg-gray-100 ${isShow && "close"}`}>
                <div className="flex items-center">
                  <input type="text" onChange={(e) => setSearch(e.target.value)} className="w-[100%] border-[1px] border-[#8080803b] rounded-[10px] py-[8px] px-[10px] focus-within:outline-[#0d9488]" placeholder={t("Search...")} />
                  <IoSearchOutline className="-ms-[27px]" />
                </div>
                <div className="mt-[10px] h-[100%] scroll-container pb-[43px]">
                  {filterData.length >= 1
                    ? filterData.map((item, index) => {
                      return <div onClick={() => HandleSelectUser(item)} key={index} className={`w-[100%] py-[10px] px-[8px] flex items-center gap-[10px] cursor-pointer ${index !== 0 && "border-t-[1px] border-gray-400"}`}>
                        <div className="w-[50px] h-[50px] min-w-[50px] rounded-[100%] overflow-hidden">
                          <img src={ImgBaseUrl + item.logo} className="w-[100%] h-[100%] object-cover" alt="" />
                        </div>
                        <div className="w-[70%] max-_770_:w-[90%] overflow-hidden overflow-ellipsis">
                          <h1 className="whitespace-nowrap overflow-hidden overflow-ellipsis">{item.name}</h1>
                          <span className="whitespace-nowrap overflow-ellipsis text-gray-600">{item.message}</span>
                        </div>
                        {(item.status === "0")
                          ? <span>{item.date}</span>
                          : <div className="w-[8px] h-[8px] rounded-[50px] bg-[#0d9488]"></div>
                        }
                      </div>
                    })
                    : <div className="h-full flex items-center justify-center">
                      <h1>{t("No Doctors found !!")}</h1>
                    </div>}
                </div>
              </div>

              <div ref={ClassRef} className={`user_chat ${isShow ? "chat_open" : ""}`} >
                <div className="select_box mb-[5px]">
                  <div className="flex items-center gap-[10px]">
                    {selectUser && <button className="chat_icon" onClick={() => setIsShow(false)} ><IoIosArrowBack className="text-[20px]" /></button>}
                    {selectUser && <img src={ImgBaseUrl + selectUser?.logo} className="user_img" alt="" />}
                    <h1 className="font-[500] text-[17px]">{selectUser ? selectUser?.name : t("Select User")}</h1>
                  </div>
                </div>

                <div onScroll={handleScroll} ref={chatBoxBodyRef} className="h-full scroll-container px-2.5 chat_bg">
                  {false ? (
                    <Loading CustomeStyle="h-full flex items-center justify-center" />
                  ) : selectUser && chatData.length > 0 ? (
                    chatData.slice().reverse().map((dayData, dateIndex) => (
                      <div key={dateIndex} className="mb-1.5 mt-2.5">
                        <h1 className="text-center font-medium text-sm">{dayData.date}</h1>
                        {dayData.chat.slice().reverse().map((chatItem, chatIndex) => (
                          <div key={chatIndex} className="msg_list mt-1.5">
                            <div
                              className={`message bg-gray-100 ${chatItem.status === 1 ? "sender" : "recevier"
                                }`}
                            >
                              <pre className="font-medium whitespace-pre-wrap">{chatItem.message}</pre>
                              <span className="text-sm">{chatItem.date}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))
                  ) : (
                    <div className="h-full flex items-center justify-center">
                      <h1>{t("No messages found !!")}</h1>
                    </div>
                  )}
                </div>

                <div className="send_box mt-[5px]">
                  <input
                    value={input}
                    onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSendMessage();
                      }
                    }} type="text" className='w-[100%] border-[2px] border-[#8080803b] rounded-[10px] py-[8px] px-[10px] font-[500] focus-within:border-[#0d9488]' placeholder={t('Say Something...')} />
                  <button onClick={handleSendMessage} className="bg-[#0d9488] rounded-[10px] p-[10px]"><IoMdSend className="text-[20px] text-white" /></button>
                </div>

              </div>

            </div>
          }
        </div>}
    </div>
  )
}

export default Chat
/* jshint ignore:end */